module.exports = "<div class=\"videoMediaCategoriesCon\" fxLayout=\"column\">\n\n  <!-- For Loading the video -->\n\n  <app-mediavideocommon (onSelectGvideo)=\"getDriveVideo($event)\" [updateData]=\"videoThumbUrl\" [bookObj]=\"bookObj\" style=\"height:100%;\"></app-mediavideocommon>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/bookShared/bookeditoption/bookEditOptionPopups/media/video/videogallerymedia/videogallerymedia.component.html
// module id = ./src/app/bookShared/bookeditoption/bookEditOptionPopups/media/video/videogallerymedia/videogallerymedia.component.html
// module chunks = main